const Queries = function () {
    return {
        PENDING_REQUESTS: "pendingRequests",
        PENDING_BOOKING_REQUESTS: "pendingBookingRequests",
        ROOM_BOOKINGS: "roomBookings"
    }
}

export default Queries();
